import React, { Component } from 'react'
import styled from 'styled-components'
import { Select } from 'advenio-components'
import { Form } from 'formsy-react' //eslint-disable-line
import moment from 'moment'

const Body = styled.div`
  display: flex;
  justify-content: center;
  flex:1;
`
const TimerContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
`
const NewSelect = styled(Select)`
  margin: 16px;
  width: ${({ large }) => large ? '80px' : '65px'};
  &:first-of-type {
    margin-right: 8px;
  }
`
const NewForm = styled(Form)`
  display: flex;
  flex:1;
`
const hours = [
  { value: 1, label: '1', id: 1 },
  { value: 2, label: '2', id: 2 },
  { value: 3, label: '3', id: 3 },
  { value: 4, label: '4', id: 4 },
  { value: 5, label: '5', id: 5 },
  { value: 6, label: '6', id: 6 },
  { value: 7, label: '7', id: 7 },
  { value: 8, label: '8', id: 8 },
  { value: 9, label: '9', id: 9 },
  { value: 10, label: '10', id: 10 },
  { value: 11, label: '11', id: 11 },
  { value: 12, label: '12', id: 12 },
]

const minutes = [
  { value: '00', label: '00', id: '00' },
  { value: 15, label: '15', id: '15' },
  { value: 30, label: '30', id: '30' },
  { value: 45, label: '45', id: '45' },
]

const time = [{ value: 'am', label: 'AM', id: 'am' }, { value: 'pm', label: 'PM', id: 'pm' }]

class TimePicker extends Component {
  state = {
    hour: 9,
    minute: '00',
    ampm: 'am',
  }

  getTwentyFourHourTime = (date) => {
    const d = moment(date, 'hh:mm a')
    const newHour = Number(d.hours()) < 10 ? this.addZero(d.hours()) : d.hours()
    const newMinute = Number(d.minutes()) < 10 ? this.addZero(d.minutes()) : d.minutes()
    return `${newHour}:${newMinute}`
  }

  getValue = () => {
    const { hour, minute, ampm } = this.state
    const timeSelected = `${hour}:${minute} ${ampm}`
    return this.getTwentyFourHourTime(timeSelected)
  }

  handleChange = (value, attribute) => {
    const dataToUpdate = {}
    dataToUpdate[attribute] = value
    this.setState(dataToUpdate)
  }


  addZero = i => i < 10 ? `0${i}` : i


  render() {
    return (
      <Body>
        <TimerContainer>
          <NewSelect
            name="hour"
            label="Hora"
            value={hours[8].value}
            options={hours}
            hideEmptyHelpBlock
            onChangeCallback={(e) => { this.handleChange(e.currentTarget.value, 'hour') }}
          />
          <NewSelect
            name="minute"
            label="Minutos"
            value={minutes[0].value}
            options={minutes}
            hideEmptyHelpBlock
            large
            onChangeCallback={(e) => { this.handleChange(e.currentTarget.value, 'minute') }}
          />
          <NewSelect
            name="ampm"
            label="Periodo"
            value={time[0].value}
            options={time}
            hideEmptyHelpBlock
            onChangeCallback={(e) => { this.handleChange(e.currentTarget.value, 'ampm') }}
          />
        </TimerContainer>
      </Body>
    )
  }
}

export default TimePicker



// WEBPACK FOOTER //
// ./src/Components/TimePicker/TimePicker.jsx